// Lightweight singleton to mirror React state to the service layer,
// so services can always read the freshest values (no stale props).
// Pure JS, no React imports needed.

let _snapshot = {
  version: 0,
  isSubmitting: false, // single-flight guard for "Confirm & Pay"
};

let _actions = {}; // optional callbacks services may invoke (prevStep, nextStep, etc.)
const _listeners = new Set();

function _notify() {
  _listeners.forEach((fn) => {
    try {
      fn(_snapshot);
    } catch (_) {}
  });
}

export const BookingBridge = {
  // ===== context -> bridge =====
  setSnapshot(partial) {
    _snapshot = { ..._snapshot, ...partial, version: _snapshot.version + 1 };
    _notify();
  },
  setActions(actions) {
    _actions = { ..._actions, ...actions };
  },

  // ===== services -> bridge =====
  getSnapshot() {
    return _snapshot;
  },
  getActions() {
    return _actions;
  },

  // subscribe (handy for diagnostics/tests)
  subscribe(fn) {
    _listeners.add(fn);
    return () => _listeners.delete(fn);
  },

  // single-flight submit guard
  beginSubmit() {
    if (_snapshot.isSubmitting) return false;
    BookingBridge.setSnapshot({ isSubmitting: true });
    return true;
  },
  endSubmit() {
    BookingBridge.setSnapshot({ isSubmitting: false });
  },

  // DEV helper (optional)
  reset() {
    _snapshot = { version: 0, isSubmitting: false };
    _actions = {};
    _listeners.clear?.();
  },
};

export default BookingBridge;
